export default "__VITE_ASSET__BLHlxXwn__"